import m from "../../geodata/es2015/saudiArabiaLow";
window.am4geodata_saudiArabiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saudiArabiaLow.js
// module id = null
// module chunks = 